import { render, staticRenderFns } from "./HomeTrivia2.vue?vue&type=template&id=2a4db4d0"
import script from "./HomeTrivia2.vue?vue&type=script&lang=js"
export * from "./HomeTrivia2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports